var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArtist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 40,
    viewBox: "0 0 33 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4858 19.3836L29.2853 14.7423H27.6609L24.0142 18.2449L16.4509 0L8.8877 18.2033L5.25547 14.7435H3.63L8.4072 19.3589L0 39.5936L2.72807 39.6195L10.0449 20.94L16.4643 27.141L22.896 20.922L30.273 39.6206H32.8729L24.4858 19.3836ZM16.5056 25.4588L10.5109 19.7496L16.4509 4.58733L22.4378 19.7609L16.5056 25.4588Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtist);
export default __webpack_public_path__ + "static/media/Artist.bbb2c3297c3f383a5db83998ae9e1d2b.svg";
export { ForwardRef as ReactComponent };